import type { Product } from "./schema";

// Given a product and the full list of brand products, returns the ordered
// list of products to render on an LP Express page:
//   - If the product is a bundle with a non-empty bundleProductIds list, resolve
//     those member SKUs (in their stored order, skipping archived/missing ones).
//   - Otherwise (non-bundle, empty/missing bundleProductIds, or all members
//     unresolved) fall back to the single product itself.
// Nested bundles are NOT expanded — a member that is itself a bundle is treated
// as a plain product.
export function expandBundleProducts(
  product: Product | null | undefined,
  allProducts: Product[],
): Product[] {
  if (!product) return [];
  const ids = Array.isArray(product.bundleProductIds)
    ? (product.bundleProductIds as string[])
    : [];
  if (!product.isBundle || ids.length === 0) return [product];
  const byId = new Map(allProducts.map((p) => [p.id, p]));
  const members = ids
    .map((id) => byId.get(id))
    .filter((p): p is Product => !!p && !p.archivedAt);
  return members.length > 0 ? members : [product];
}
